import {Browser} from '@capacitor/browser';
import type {PluginListenerHandle} from '@capacitor/core';

import {useAdminHomeStore} from '@app/stores';

let finishedListener: PluginListenerHandle | undefined;

/**
 * iOS app: run a manual (card-present) charge in the in-app browser (SFSafariViewController).
 * PayMe's hosted card fields are iframes that take no touches inside the app's WKWebView,
 * but work normally in Safari. Opens the public pay page `/p/{uuid}`; the payment request's
 * `manualCharge` flag makes the server offer up to 12 installments and hide wallets there.
 *
 * We can't tell from here whether the charge went through, so on close we only refresh
 * the calendar — the appointment's paid state shows there.
 */
export const openManualChargeInBrowser = async (paymentUuid: string): Promise<void> => {
  await finishedListener?.remove();
  finishedListener = await Browser.addListener('browserFinished', () => {
    useAdminHomeStore().fetchBusinessCalendarDataSilently();
    finishedListener?.remove();
    finishedListener = undefined;
  });
  await Browser.open({
    url: `${import.meta.env.VITE_BUSINESS_WEBSITE_DOMAIN}/p/${encodeURIComponent(paymentUuid)}`,
    presentationStyle: 'popover',
  });
};
